// components/admin/countries/CountryTable.jsx
import React from 'react';
import { Switch } from "../ui/switch";
import { Button } from "../ui/button";
import { PencilIcon } from "lucide-react";
import toast from "react-hot-toast";
const API = process.env.REACT_APP_API_BASE;

export default function CountryTable({ countries, setCountries, onEdit }) {
  const handleStatusToggle = (countryId, newStatus) => {
    fetch(`${API}/api/countries/${countryId}/status`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: newStatus })
    })
      .then(res => res.json())
      .then(updated => {
        setCountries(updated);
        toast.success('Status updated');
      })
      .catch(() => toast.error('Failed to update status'));
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="bg-muted text-left">
            <th className="p-3">Name</th>
            <th className="p-3">ISO</th>
            <th className="p-3">Currency</th>
            <th className="p-3">Date Format</th>
            <th className="p-3">Language</th>
            <th className="p-3">Default</th>
            <th className="p-3">Status</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {countries.map(country => (
            <tr key={country._id} className="border-t">
              <td className="p-3">{country.name}</td>
              <td className="p-3">{country.isoCode}</td>
              <td className="p-3">{country.currency}</td>
              <td className="p-3">{country.dateFormat}</td>
              <td className="p-3">{country.defaultLanguage}</td>
              <td className="p-3">{country.isDefault ? 'Yes' : 'No'}</td>
              <td className="p-3">
                <Switch
                  checked={country.status}
                  onCheckedChange={(val) => handleStatusToggle(country._id, val)}
                />
              </td>
              <td className="p-3">
                <Button size="sm" variant="outline" onClick={() => onEdit(country)}>
                  <PencilIcon className="w-4 h-4" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
